export enum Language {
  EN = 'en',
  PL = 'pl',
}
